export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8335.9c4729d9.jpg";